import { I18n } from "@assets/strings";
import React from "react";
import { useHistory } from "@core/routing/useHistory";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { Group, GroupMemberRole } from "@domain/group/group";
import { useGroup } from "@domain/group/hooks";
import { useAsync } from "@utils/hooks";
import { createToast } from "@ui/toasts/utils";
import { LoadingButton } from "@ui/components/buttons/loadingButton";

interface JoinGroupButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	groupId: string;
	role: GroupMemberRole;
}
export const JoinGroupButton: React.FC<JoinGroupButtonProps> = ({ groupId, role, ...htmlProps }) => {
	const { result: group } = useGroup(groupId);

	return group ? <JoinGroupContent group={group} role={role} {...htmlProps} /> : null;
};

interface JoinGroupContentProps extends React.HTMLAttributes<HTMLButtonElement> {
	group: Group;
	role: GroupMemberRole;
}
const JoinGroupContent: React.FC<JoinGroupContentProps> = ({ group, role, ...htmlProps }) => {
	const { groupService } = useServices();
	const history = useHistory();
	const { run, loading } = useAsync(async () => {
		await groupService.joinGroup(group.id, role);
		history.push(Path.Discussion(group));
		createToast(I18n.t("success"), I18n.t(`group.${group.type}.join.success`, { name: group.name }), "success");
	}, [group]);

	if (group.status !== "PENDING_GUEST_ACCEPTANCE") {
		return null;
	}

	return (
		<LoadingButton loading={loading} onClick={run} buttonType="secondary" {...htmlProps}>
			{I18n.t("group.join.button")}
		</LoadingButton>
	);
};
